var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.listsLoaded)?_c('v-list',{attrs:{"dense":"","nav":""}},_vm._l((_vm.lists),function(item){return _c('v-list-item',{key:item.id,attrs:{"link":"","to":_vm.getRouteLink(item)}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(item.emoji)+" "+_vm._s(_vm.listHelper.getName(item)))])],1)],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }